export interface PostHogAnalyticsConfig {
  enabled: boolean;
  replayEnabled: boolean;
  token: string | null;
  apiHost: string;
  uiHost: string;
  environment: string;
  release: string;
}

function readBoolean(value: string | undefined, fallback: boolean): boolean {
  if (value == null || value === "") return fallback;
  return ["1", "true", "yes", "on"].includes(value.toLowerCase());
}

export function getPostHogAnalyticsConfig(
  env: ImportMetaEnv = import.meta.env
): PostHogAnalyticsConfig {
  const token = env.VITE_POSTHOG_PROJECT_TOKEN?.trim() || null;
  const enabled = Boolean(token) && readBoolean(env.VITE_POSTHOG_ENABLED, true);

  return {
    enabled,
    replayEnabled: enabled && readBoolean(env.VITE_POSTHOG_REPLAY_ENABLED, true),
    token,
    apiHost: env.VITE_POSTHOG_API_HOST || "https://a.latend.com",
    uiHost: env.VITE_POSTHOG_UI_HOST || "https://eu.posthog.com",
    // Demo deploys as Vercel "production"; the DF class tells demo and UAT apart.
    environment: env.VITE_DF_ENVIRONMENT || env.VITE_VERCEL_ENV || env.MODE || "development",
    release: env.VITE_RELEASE || "unknown",
  };
}
